import React, { useEffect, useState } from 'react';
import '../profile.css';
import './seller-support.css';
import api from '../../seller-apis/api';
import { Modal } from 'react-bootstrap';
import Loader from '../common/Loader'
// image import file 
import fileImage from '../../assets/images/fileImage1.png' // file image
import fileVideo from "../../assets/images/fileVideo1.png" // video image
import convertFileToWebP from '../../utilities/convertFileToWebP'; // utilities
import axios from 'axios'; // axios
import { variables } from "../../Variables.json";  //jason
import { useAlert } from 'react-alert';
import servicesApi from '../../seller-apis/servicesApi';
import { GenUtilities } from '../../utilities/GenUtilities';

const typeList = [
    {
        label: "Inventory related",
        key: 'INVENTORY RELATED'
    },
    {
        label: "Payment related",
        key: "PAYMENT RELATED"
    },
    {
        label: "Dispatch related",
        key: "DISPATCH RELATED"
    },
    {
        label: "Damage related",
        key: "DAMAGE RELATED"
    },
    {
        label: "Others",
        key: "OTHERS"
    }
];

const initialForm = {
    req_type: '',
    desc: '',
    orderId: ''
};

function SellerSupportForm() {

    const [form, setForm] = useState(initialForm);

    const [errors, setErrors] = useState({})

    const [modal, setModal] = useState(false);
    const [confirmationPopup, setConfirmationPopup] = useState(false);

    const [ticketNo, setTicketNo] = useState("");

    const [loader, setLoader] = useState(false);
    // image states
    const [urlListshow, seturlListshow] = useState(false);
    const [image1, setimage1] = useState("");
    const [image2, setimage2] = useState("");
    const [image3, setimage3] = useState("");
    const [vendorId, setvendorId] = useState(localStorage.getItem("vendorId"));
    const [vidurlListshow, setvidurlListshow] = useState(false);
    const [vidurlList, setvidurlList] = useState([]);
    const [finalImage, setFinalImage] = useState([])
    var s3Urls = [];
    var imagesName = [];
    var videosName = [];
    var vids3Urls = [];
    const alert = useAlert();
    console.log("image1", image1, urlListshow);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prevData) => ({
            ...prevData,
            [name]: value
        }));
        if (errors[name]) {
            setErrors((prevData) => ({
                ...prevData,
                [name]: undefined
            }))
        }
    }

    const handlePopup = (e) => {
        e.preventDefault();
        if (handleValidation()) {
            setConfirmationPopup(true)
        } else {
            setConfirmationPopup(false)
        }
    }

    const handleSubmit = async () => {
        setConfirmationPopup(false)
        setLoader(true);
        //media jason
        const media = finalImage?.map((item) => {
            return {
                mediaType: item?.mediaType,
                url: item?.url
            }
        })

        const res = await api.Support.add({
            ...form, 
            desc: form.desc.trim(), 
            media: media,
            type:"issues"
        });
        setTicketNo(res.data.data.ticket_no);
        setModal(true);
        handleReset();
        setLoader(false);
        setimage1("")
        setimage2("")
        setimage3("")
        setvidurlList([]);
    }

    const handleReset = () => {
        setForm({ ...initialForm });
        if (Object.keys(errors).length) {
            setErrors({})
        }
        setimage1("")
        setimage2("")
        setimage3("")
        setFinalImage([])
        setvidurlListshow(false);
        setvidurlList([]);
    }

    const handleValidation = () => {
        const newErrors = {};

        if (!form.req_type) {
            newErrors.req_type = 'Type is required.';
        }

        if (!form.desc || !form.desc.trim().length) {
            newErrors.desc = 'Description is required.';
        }

        setErrors(newErrors);

        return !Object.keys(newErrors).length
    }

    //image
    //image upload function
    const handleFileChange = async (e, spcl) => {

        let comImg;
        let imageFinal;
        let registerImage;
        let isimgsSizevalid = true;
        let limit = e.target.files.length;
        const maxSize = 2 * 1024 * 1024;
        const allowedImageExtensions = [".png", ".jpg", ".jpeg"];

        seturlListshow(false);
        for (let i = 0; i < limit; i++) {
            const file = e.target.files[i];
            const FileExtension = file.name.slice(file.name.lastIndexOf(".")).toLowerCase();

            if (!allowedImageExtensions.includes(FileExtension)) {
                alert.info("Only PNG, JPG, and JPEG images are allowed.");
                continue;
            }

            if (file.size > maxSize) {
                alert?.info("A max size of 2 Mb image can be uploaded");
                continue;
            }
            let convertedImg = await convertFileToWebP(e.target.files[i]);
            const originalBlob = convertedImg;
            const strArray = convertedImg.name.split(".");
            const newName = strArray[0] + "-" + new Date().getTime() + "." + strArray[1];
            const renamedFile = new File([originalBlob], newName, { type: convertedImg.type });
            // var str = convertedImg.name;
            let extension = convertedImg.name.slice(
                convertedImg.name.lastIndexOf(".")
            );
            // comImg = str.replace(/[^\w]/g, "");
            comImg = newName.replace(/[^\w]/g, "");
            // imageFinal = "img_" + vendorId + "_" + comImg + extension;
            imageFinal = GenUtilities.removeSpacesFromName("img_" + vendorId + "_" + newName)
            // registerImage = convertedImg;
            // registerImage = e.target.files[i];
            var data = {
                imageName: "seller/support/" + imageFinal,
            };
            imagesName.push(imageFinal);
            seturlListshow(true);
            console.log("imageFinal", imageFinal);

            switch (spcl) {
                case "image1":
                    setimage1(e.target.files[i]);
                    break;
                case "image2":
                    setimage2(e.target.files[i]);
                    break;
                case "image3":
                    setimage3(e.target.files[i]);
                    break;
            }
            const formdata = new FormData();
            formdata.append("file", renamedFile);
            servicesApi
                .getUploadUrl(data)
                .then((res) => {
                    console.log(res)
                    axios({
                        method: "post",
                        url: res.data,
                        data: formdata,
                        onUploadProgress: (data) => {
                            //Set the progress value to show the progress bar
                            // setimgprogress(Math.round((100 * data.loaded) / data.total));
                        },
                    })
                        .then((response) => {
                            console.log("response", response);
                            console.log("url === ", response?.data?.result.variants);
                            setFinalImage((prev) => {
                                const updatedImages = [...prev];
                                const index = updatedImages.findIndex((img) => img.name === spcl);

                                const newImage = {
                                    mediaType: "image",
                                    url: response?.data?.result?.variants[0],
                                    name: spcl,
                                };

                                if (index !== -1) {
                                    updatedImages[index] = newImage; // Replace existing image
                                } else {
                                    updatedImages.push(newImage); // Add new image
                                }

                                return updatedImages;
                            });

                            // setFinalImage((prev) => [...prev, {
                            //     mediaType: "image",
                            //     url: response?.data?.result?.variants[0],
                            //     name: spcl
                            // }])
                            seturlListshow(true);
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                })
                .catch((err) => console.log(err));
            // api.product
            //     .saveProductImage(data)
            //     .then((res) => {
            //         axios({
            //             method: "put",
            //             url: res.data,
            //             data: registerImage,
            //         })
            //             .then((response) => {
            //                 setFinalImage((prev) => [...prev, {
            //                     mediaType: "image",
            //                     url: response?.config?.url.split("?")[0],
            //                     name: spcl
            //                 }])
            //                 seturlListshow(true);
            //             })
            //             .then((response) => {
            //                 seturlListshow(true);
            //             })
            //             .catch((error) => {
            //                 console.log(error);
            //             });
            //     })
            //     .catch((err) => console.log(err));
            s3Urls.push(imageFinal);
        }
    }

    //video
    //video upload function
    const showVideo = (event) => {
        setvidurlListshow(false);
        let comImg;
        let imageFinal;
        let registerImage;
        let videoSize = 0;
        const allowedVideoExtensions = [".mp4", ".mov"];
        const files = Array.from(event.target.files);

        if (event.target.files.length > 1 || vidurlList.length === 1) {
            alert.info("A max of 1 video can be uploaded");
            setvidurlListshow(true);
        }

        const file = files[0];
        const extension = file.name.slice(file.name.lastIndexOf(".")).toLowerCase();

        if (!allowedVideoExtensions.includes(extension)) {
            alert.info("Only MP4 and MOV videos are allowed.");
            setvidurlListshow(true);
            return;
        }

        if (event.target.files.length > 0) {
            for (let i = 0; i < 1; i++) {
                videoSize = videoSize + event.target.files[i].size;
            }
            if (videoSize <= variables.limit.Newproductupload.video) {
                for (let i = 0; i < 1; i++) {
                    var str = event.target.files[i].name;
                    let extension = event.target.files[i].name.slice(
                        event.target.files[i].name.lastIndexOf(".")
                    );
                    comImg = str.replace(/[^\w]/g, "");
                    imageFinal = "vid_" + vendorId + "_" + comImg + extension;
                    registerImage = event.target.files[0];
                    var data = {
                        imageName: imageFinal,
                        type: "products",
                        bucket: "m",
                    };
                    imageFinal = GenUtilities.removeSpacesFromName("products/vid_" + vendorId + "_" + comImg + extension);
                    videosName.push(imageFinal);
                    api.product
                        .saveProductImage(data)
                        .then((res) => {
                            axios({
                                method: "put",
                                url: res.data,
                                data: registerImage,
                            })
                                .then((response) => {
                                    console.log("res", response);
                                    setFinalImage((prev) => [...prev, {
                                        mediaType: "video",
                                        url: response?.config?.url.split("?")[0],
                                    }])
                                    setvidurlList(videosName);
                                    setvidurlListshow(true);
                                })
                                .then((response) => {
                                    setvidurlList(videosName);
                                    setvidurlListshow(true);
                                })
                                .catch((error) => {
                                    console.log(error);
                                });
                        })
                        .catch((err) => console.log(err));
                    vids3Urls.push(imageFinal);
                }
            } else {
                alert.info("A max size of 15 Mb video can be uploaded");
            }
        }
    }

    //image remove function
    const handleRemoveAttachment = (e, id) => {
        e.preventDefault();
        e.stopPropagation();
        console.log("imagesName", imagesName);

        imagesName.splice(id, 1);
        switch (id) {
            case "image1":
                setimage1("");
                break;
            case "image2":
                setimage2("");
                break;
            case "image3":
                setimage3("");
                break;
        }
        setFinalImage((prev) => prev.filter((item) => item.name !== id));
        // let eleLoader = document.getElementById(ele);
        // eleLoader.setAttribute("class", "spinner-border text-info")
    };
    console.log("finalimage", finalImage);

    //video delete function 
    const deletevideo = (e, index, id) => {
        e.preventDefault();
        e.stopPropagation();
        setvidurlListshow(false);
        setvidurlList([]);
        videosName.splice(index, 1);
        let eleLoader = document.getElementById("loader-Vid-upload");
        setFinalImage((prev) => prev.filter((item) => item.mediaType !== id));
        setvidurlList(videosName);

        eleLoader.setAttribute("class", "spinner-border text-info");

        setTimeout(() => {
            eleLoader.removeAttribute("class");

            setvidurlListshow(true);
        }, 1000);
    }

    return (
        <>

            <form onSubmit={handlePopup} onReset={handleReset} className='seller-support-form'>

                <div className='seller-support-form__field'>
                    <div className='row align-items-start flex-direction-column'>
                        <div className='col-md-2 col-sm-12'>
                            <label className='fs-12'>
                                Type
                            </label>
                        </div>
                        <div className='col-md-2 col-sm-12'>
                            <select
                                value={form.req_type}
                                name="req_type"
                                onChange={handleChange}
                                className='profile-input'
                                placeholder='Select Type'

                            >
                                <option value='' hidden>Select your option...</option>
                                {
                                    typeList.map((type) =>
                                        <option key={type.key} value={type.key}>
                                            {type.label}
                                        </option>
                                    )
                                }
                            </select>
                        </div>
                        <div className='offset-2 col-10'>
                            {errors.req_type && <span className="error">{errors.req_type}</span>}
                        </div>
                    </div>

                </div>

                {/* SL-953 (3-10-25)*/}
                <div className='seller-support-form__field'>
                    <div className='row align-items-start flex-direction-column'>
                        <div className='col-md-2 col-sm-12'>
                            <label className='fs-12'>
                                Order ID
                            </label>
                        </div>
                        <div className='col-md-2 col-sm-12'>
                            <input type='text'
                                className='profile-input'
                                onChange={handleChange}
                                name='orderId'
                                value={form.orderId}
                            />
                        </div>
                        <div className='offset-2 col-10'>
                            {errors?.orderId && <span className="error">{errors?.orderId}</span>}
                        </div>
                    </div>

                </div>
                {/* SL-953 (3-10-25) ends*/}
                <div className='seller-support-form__field'>
                    <div className='row align-items-start flex-direction-column'>
                        <div className='col-md-2 col-sm-12'>
                            <label className='fs-12'>
                                Description
                            </label>
                        </div>
                        <div className='col-md-6 col-sm-12'>
                            <textarea
                                value={form.desc}
                                name="desc"
                                onChange={handleChange}
                                className='profile-input'
                                placeholder='Enter description here...'
                                rows={4}
                            />
                        </div>
                        <div className='offset-2 col-10'>
                            {errors.desc && <span className="error">{errors.desc}</span>}
                        </div>
                    </div>
                </div>
                <div className='seller-support-form__field'>
                    <div className='row align-items-start flex-direction-column'>
                        <div className='col-md-2 col-sm-12'>
                            <label className='fs-12'>
                                Attachments
                            </label>
                        </div>
                        <div className='col-md-6 col-sm-12'>
                            <div className='seller-support-form-attachments'>
                                <div>
                                    <div className='attachment-box'>
                                        <input type='file' accept=".jpg, .jpeg, .png" id="image1" name='image1' className='file-input' onChange={(e) => handleFileChange(e, 'image1')} />
                                        <label htmlFor="image1" className='upload-label'>
                                            {(urlListshow === true &&
                                                image1 !== undefined &&
                                                image1 !== "") && (
                                                    <button
                                                        className="close-button"
                                                        onClick={(e) => handleRemoveAttachment(e, 'image1')}
                                                    >
                                                        ×
                                                    </button>
                                                )}
                                            {console.log("image ==== ", image1)}
                                            <img
                                                src={urlListshow === true &&
                                                    image1 !== undefined &&
                                                    image1 !== "" ? URL.createObjectURL(image1) : fileImage}
                                                alt="Uploaded"
                                                className="uploaded-preview"
                                            />
                                            {!image1 && <span>Upload Image</span>}
                                        </label>
                                    </div>
                                    <div className="add_pro_form_video mt-4 ms-4">
                                        <div className="video-instruction">
                                            <span>1. Size Max 2 Mb</span>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className='attachment-box'>
                                        <input type='file' accept=".jpg, .jpeg, .png" id="image2" name='image2' className='file-input' onChange={(e) => handleFileChange(e, 'image2')} />
                                        <label htmlFor="image2" className='upload-label'>
                                            {(urlListshow === true &&
                                                image2 !== undefined &&
                                                image2 !== "") && (
                                                    <button
                                                        className="close-button"
                                                        onClick={(e) => handleRemoveAttachment(e, 'image2')}
                                                    >
                                                        ×
                                                    </button>
                                                )}
                                            <img
                                                src={urlListshow === true &&
                                                    image2 !== undefined &&
                                                    image2 !== "" ? URL.createObjectURL(image2) : fileImage}
                                                alt="Uploaded"
                                                className="uploaded-preview"
                                            />
                                            {!image2 && <span>Upload Image</span>}
                                        </label>
                                    </div>
                                    <div className="add_pro_form_video mt-4 ms-4">
                                        <div className="video-instruction">
                                            <span>1. Size Max 2 Mb</span>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className='attachment-box'>
                                        <input type='file' accept=".jpg, .jpeg, .png" id="image3" name='image3' className='file-input' onClick={(e) => e.target.value = null} onChange={(e) => handleFileChange(e, 'image3')} />
                                        <label htmlFor="image3" className='upload-label'>
                                            {(urlListshow === true &&
                                                image3 !== undefined &&
                                                image3 !== "") && (
                                                    <button
                                                        className="close-button"
                                                        onClick={(e) => handleRemoveAttachment(e, 'image3')}
                                                    >
                                                        ×
                                                    </button>
                                                )}
                                            <img
                                                src={urlListshow === true &&
                                                    image3 !== undefined &&
                                                    image3 !== "" ? URL.createObjectURL(image3) : fileImage}
                                                alt="Uploaded"
                                                className="uploaded-preview"
                                            />
                                            {!image3 && <span>Upload Image</span>}
                                        </label>
                                    </div>
                                    <div className="add_pro_form_video mt-4 ms-4">
                                        <div className="video-instruction">
                                            <span>1. Size Max 2 Mb</span>
                                        </div>
                                    </div>
                                </div>
                                <div className=''>
                                    <div className='attachment-box'>
                                        <input type='file' accept=".mp4, .mov" id="video1" name='video1' className='file-input' onClick={(e) => e.target.value = null} onChange={(event) => showVideo(event)} />
                                        <label htmlFor="video1" className='upload-label'>
                                            {vidurlListshow === true ? (
                                                vidurlList.map((item, index) => {
                                                    return (
                                                        <>
                                                            <button
                                                                className="close-button"
                                                                onClick={(e) => deletevideo(e, index, "video")}
                                                            >
                                                                ×
                                                            </button>
                                                            <video
                                                                src={"https://media.toolsvilla.com/" +
                                                                    item}
                                                                // autoPlay
                                                                controls
                                                                className="uploaded-preview"
                                                            />
                                                        </>

                                                    )
                                                }
                                                )) : ""}
                                            {vidurlListshow === false && <img src={fileVideo} alt="Upload Video" />}
                                            {vidurlListshow === false && <span>Upload Video</span>}
                                        </label>
                                    </div>
                                    <div className="add_pro_form_video mt-4 ms-4">
                                        <div className="video-instruction">
                                            <span>1. Size Max 15 Mb</span>
                                            <br></br>
                                            <span>2. Format - MP4</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className='offset-2 col-10'>
                            {errors.desc && <span className="error">{errors.desc}</span>}
                        </div> */}
                    </div>
                </div>

                <div className='seller-support-form__btns'>
                    <div className='row'>
                        <div className='d-flex col'>

                            <button type='submit' className='seller-support-form__btn seller-support-form__btn--submit me-3'>
                                SUBMIT
                            </button>
                            <button type='reset' className='seller-support-form__btn seller-support-form__btn--cancel'>
                                CANCEL
                            </button>
                        </div>
                    </div>
                </div>

            </form>
            <Modal show={confirmationPopup} centered>
                <Modal.Body className='seller-support-confirmation-popup'>
                    <div className='seller-support-confirmation-popup__heading'>
                        Do you want to submit the ticket ?
                    </div>
                    <div className='seller-support-confirmation-popup__buttons'>
                        <button className='seller-support-confirmation-popup__buttons seller-support-confirmation-popup__button--yes' onClick={handleSubmit}>
                            Yes
                        </button>
                        <button className='seller-support-confirmation-popup__buttons seller-support-confirmation-popup__button--no' onClick={() => setConfirmationPopup(false)}>
                            No
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal show={modal} size="lg" centered>
                <Modal.Body>
                    <div className='px-2 pb-2'>
                        <div className='text-end'>
                            <img src="/common/cross.png" alt="Close" height={17} className='cursor-pointer' onClick={() => setModal(false)} />
                        </div>

                        <div className='text-center'>
                            <div className='pt-3 pb-2 seller-support-ticket-popup__heading'>
                                Ticket id
                                <span className='pt-3 pb-2 seller-support-ticket-popup__heading--primary'>
                                    {ticketNo}
                                </span> raised successfully.
                            </div>
                            <div className='pb-5 seller-support-ticket-popup__sub-heading mx-auto'>
                                Toolsvilla team will get back to you soon.
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Loader show={loader} />
        </>
    )

}

export default SellerSupportForm;